import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['positiveModal', 'negativeModal'];

  static values = {
    createUrl: String,
    updateUrl: String,
    feedbackableType: String,
    feedbackableId: Number,
    successMessage: String,
    errorMessage: String,
    preview: Boolean
  };

  vote(event) {
    const helpful = event.currentTarget.dataset.helpful === 'true';

    if (!this.previewValue) {
      this.feedbackRequest = this._request(this.createUrlValue, 'POST', this._voteBody(helpful))
        .catch(() => this._displayError());
    }

    this._open(helpful ? this.positiveModalTarget : this.negativeModalTarget);
  }

  async submit(event) {
    event.preventDefault();

    const body = new FormData(event.target);
    this._close();

    if (this.previewValue) return this._displaySuccess();

    try {
      const feedback = await this.feedbackRequest;
      if (!feedback) return;

      await this._request(this.updateUrlValue.replace(':id', feedback.id), 'PATCH', body);
      this._displaySuccess();
    } catch {
      this._displayError();
    }
  }

  skip() {
    this._close();
    this._displaySuccess();
  }

  close() {
    this._close();
  }

  _open(modal) {
    modal.querySelector('form').reset();
    modal.classList.remove('hidden');
  }

  _close() {
    this.positiveModalTarget.classList.add('hidden');
    this.negativeModalTarget.classList.add('hidden');
  }

  _voteBody(helpful) {
    const body = new FormData();

    body.append('feedbackable_type', this.feedbackableTypeValue);
    body.append('feedbackable_id', this.feedbackableIdValue);
    body.append('helpful', helpful);

    return body;
  }

  async _request(url, method, body) {
    const response = await fetch(url, {
      method,
      body,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    });

    if (!response.ok) throw new Error(response.statusText);

    return response.json();
  }

  _displaySuccess() {
    document.dispatchEvent(new CustomEvent('promote:display-success-message', {
      detail: { message: this.successMessageValue }
    }));
  }

  _displayError() {
    document.dispatchEvent(new CustomEvent('promote:display-error-message', {
      detail: { message: this.errorMessageValue }
    }));
  }
}
